export const VOLUME_CHANGE = 'VOLUME_CHANGE',
    volumeChange = (value) => ({type: VOLUME_CHANGE, value});


// WEBPACK FOOTER //
// ./src/actions/volume.js